import React, { Suspense } from "react";
import AppRouter from "./AppRouter";
import { ToastContainer } from "react-toastify";
// Lives here because this is where ToastContainer is mounted, so every toast —
// including the checkout-recovery one — is styled regardless of which page is
// on screen. Previously only the individual pages imported it.
import "react-toastify/dist/ReactToastify.css";
import CheckoutRecovery from "../components/checkout-recovery/CheckoutRecovery";

// Official Object.entries polyfill from
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#Polyfill
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}

function App() {
    return (
        <Suspense fallback="">
            <ToastContainer
                position="top-right"
                autoClose={7000}
                hideProgressBar={false}
                newestOnTop={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <AppRouter />
            <CheckoutRecovery />
        </Suspense>
    );
}

export default App;
